import { isCourseSelfPaced } from '@/composables/useSelfPacedCourse.js';
import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import Course from '@/models/Course.js';
import store from '@/store/Index.js';

async function redirectIfAsynchronousCourse(to, from, next) {
    const courseId = Number(to.params.courseId);

    if (!courseId || !Number.isFinite(courseId)) {
        return next();
    }

    let course = Course.query().find(courseId);

    if (!course) {
        await store.dispatch('Courses/fetchMinimal', { id: courseId });
        course = Course.query().find(courseId);
    }

    if (course && isCourseSelfPaced(course)) {
        return next({
            name: 'course-dashboard',
            params: { courseId: to.params.courseId },
        });
    }

    next();
}

export default [
    {
        name: 'course-attendance',
        path: '/courses/:courseId/attendance',
        component: () => import('@/pages/courses/attendance/AttendanceIndex.vue'),
        beforeEnter: redirectIfAsynchronousCourse,
        meta: {
            title: 'Attendance',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'attendances' },
            // Full-bleed this page so it uses the full page width.
            dataTablePage: true,
        },
    },
    {
        name: 'course-attendance-hours',
        path: '/courses/:courseId/attendance/hours',
        component: () => import('@/pages/courses/attendance/AttendanceHoursReport.vue'),
        beforeEnter: [FeatureMiddleware('ATTEND'), redirectIfAsynchronousCourse],
        meta: {
            title: 'Attendance hours',
            // Admin Story 10, AC-11: the dedicated reporting permission is checked by the page itself, which
            // shows the refusal in place; the API refuses a direct request too.
            dataTablePage: true,
        },
    },
];
